import React, { useEffect, useState } from 'react';
interface DeferredMountProps {
  children: React.ReactNode;
  /** Delay in ms before mounting children. Defaults to 0 (mount on next idle/frame). */
  delay?: number;
}
/**
 * Defers mounting children until after the browser has had a chance to paint
 * and become idle. Useful for non-critical interactive components (popups,
 * floating CTAs, etc.) that shouldn't compete with initial render.
 */
export function DeferredMount({
  children,
  delay = 0
}: DeferredMountProps) {
  const [shouldMount, setShouldMount] = useState(false);
  useEffect(() => {
    let cancelled = false;
    let timeoutId: number | undefined;
    let idleId: number | undefined;
    const mount = () => {
      if (!cancelled) setShouldMount(true);
    };
    const schedule = () => {
      if (typeof (window as any).requestIdleCallback === 'function') {
        idleId = (window as any).requestIdleCallback(mount, {
          timeout: 2000
        });
      } else {
        timeoutId = window.setTimeout(mount, 200);
      }
    };
    if (delay > 0) {
      timeoutId = window.setTimeout(schedule, delay);
    } else {
      schedule();
    }
    return () => {
      cancelled = true;
      if (timeoutId) window.clearTimeout(timeoutId);
      if (idleId && typeof (window as any).cancelIdleCallback === 'function') {
        ;
        (window as any).cancelIdleCallback(idleId);
      }
    };
  }, [delay]);
  if (!shouldMount) return null;
  return <>{children}</>;
}